/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { GOOGLE_MAP_INSTANCE_KEY } from '../../components/common/map/GoogleMapSingleton';
import ActionCreator from '../action-creator';
import { MapIdProp } from '../maps/actions';

interface GetFlightLegsServiceAlertsActionProps {
  missionPlanId: number;
  flightLegId: number;
  userid: string;
}

interface ReceivedSuccessProps {
  response: any;
}

interface ReceivedErrorProps {
  error: any;
}

export const ActionCreators = {
  RequestFlightLegServiceAlerts: new ActionCreator<
    'RequestFlightLegServiceAlerts',
    GetFlightLegsServiceAlertsActionProps
  >('RequestFlightLegServiceAlerts'),
  ReceivedFlightLegServiceAlertsSuccess: new ActionCreator<
    'ReceivedFlightLegServiceAlertsSuccess',
    ReceivedSuccessProps
  >('ReceivedFlightLegServiceAlertsSuccess'),
  ReceivedFlightLegServiceAlertsError: new ActionCreator<'ReceivedFlightLegServiceAlertsError', ReceivedErrorProps>(
    'ReceivedFlightLegServiceAlertsError',
  ),
  ClearReceivedFlightLegServiceAlertsError: new ActionCreator<'ClearReceivedFlightLegServiceAlertsError', undefined>(
    'ClearReceivedFlightLegServiceAlertsError',
  ),

  RequestServiceAlerts: new ActionCreator<'RequestServiceAlerts', GetFlightLegsServiceAlertsActionProps>(
    'RequestServiceAlerts',
  ),
  ClearServiceAlerts: new ActionCreator<'ClearServiceAlerts', undefined>('ClearServiceAlerts'),
  ReceivedServiceAlertsSuccess: new ActionCreator<'ReceivedServiceAlertsSuccess', ReceivedSuccessProps>(
    'ReceivedServiceAlertsSuccess',
  ),
  ReceivedServiceAlertsError: new ActionCreator<'ReceivedServiceAlertsError', ReceivedErrorProps>(
    'ReceivedServiceAlertsError',
  ),
  ClearReceivedServiceAlertsError: new ActionCreator<'ClearReceivedServiceAlertsError', undefined>(
    'ClearReceivedServiceAlertsError',
  ),

  SetIsServiceAlertDialogOpen: new ActionCreator<'SetIsServiceAlertDialogOpen', MapIdProp>('SetIsServiceAlertDialogOpen'),
  UnsetIsServiceAlertDialogOpen: new ActionCreator<'UnsetIsServiceAlertDialogOpen', MapIdProp>(
    'UnsetIsServiceAlertDialogOpen',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function getFlightLegServiceAlerts(
    missionPlanId: number,
    flightLegId: number,
    userId: string,
  ) {
  // userid is used in the header, userId is used elsewhere for other calls. the capitalization difference in the "i" is intentional
  return ActionCreators.RequestFlightLegServiceAlerts.create({ missionPlanId, flightLegId, userid: userId });
}

export function clearReceivedFlightLegServiceAlertsError() {
  return ActionCreators.ClearReceivedFlightLegServiceAlertsError.create();
}

export function getFlightLegServiceAlertsAction(
    missionPlanId: number,
    flightLegId: number,
    userId: string,
  ) {
  // userid is used in the header, userId is used elsewhere for other calls. the capitalization difference in the "i" is intentional
  return ActionCreators.RequestFlightLegServiceAlerts.create({ missionPlanId, flightLegId, userid: userId });
}

export function getServiceAlerts(
    missionPlanId: number,
    flightLegId: number,
    userId: string,
  ) {
  return ActionCreators.RequestServiceAlerts.create({
    missionPlanId,
    flightLegId,
    userid: userId,
  });
}

export function clearServiceAlerts() {
  return ActionCreators.ClearServiceAlerts.create();
}

export function clearReceivedServiceAlertsError() {
  return ActionCreators.ClearReceivedServiceAlertsError.create();
}

export function setIsServiceAlertDialogOpen(mapId = GOOGLE_MAP_INSTANCE_KEY) { 
  return () => {
    return ActionCreators.SetIsServiceAlertDialogOpen.create({ mapId });
  }
}
export function unsetIsServiceAlertDialogOpen(mapId = GOOGLE_MAP_INSTANCE_KEY) {
  return () => {
    return ActionCreators.UnsetIsServiceAlertDialogOpen.create({ mapId });
  }
}

export const flightLegServiceAlertActionWrapper = (mapId = GOOGLE_MAP_INSTANCE_KEY) => ({
  setIsServiceAlertDialogOpen: setIsServiceAlertDialogOpen(mapId),
  unsetIsServiceAlertDialogOpen: unsetIsServiceAlertDialogOpen(mapId)
})